import { useEffect } from "react";
import { INSTANCE } from "../lib/instance";
import { isCoreInstance } from "../../../shared/instance";

const ICON_BASE = "/icons/clean-glass/v1";

export function instanceAssetId(): "hub" | "core" {
  return isCoreInstance(INSTANCE) ? "core" : "hub";
}

/** Keeps favicons native to the configured instance even in Vite development/tests. */
export function useInstanceBranding(): void {
  useEffect(() => {
    const asset = instanceAssetId();
    const base = `${ICON_BASE}/${asset}`;
    document.querySelectorAll<HTMLLinkElement>("link[data-instance-icon]").forEach((link) => {
      const kind = link.dataset.instanceIcon;
      if (kind === "svg") link.href = `${base}/icon.svg`;
      else if (kind === "ico") link.href = `${base}/favicon.ico`;
      else if (kind === "16") link.href = `${base}/favicon-16.png`;
      else if (kind === "32") link.href = `${base}/favicon-32.png`;
      else if (kind === "192") link.href = `${base}/icon-192.png`;
      else if (kind === "512") link.href = `${base}/icon-512.png`;
      else if (kind === "apple") link.href = `${base}/apple-touch-icon.png`;
    });
    const appleTitle = document.querySelector<HTMLMetaElement>('meta[name="apple-mobile-web-app-title"]');
    if (appleTitle) appleTitle.content = asset === "core" ? "CORE" : "Hub";
  }, []);
}
